import { Buffer } from "buffer";
import sha256 from "crypto-js/sha256";
import { urlEncodeB64 } from "./urlEncodeB64";

export function generateChallenge(verifier: string): string {
    const hash = sha256(verifier).toString();

    return urlEncodeB64(Buffer.from(hash, "hex").toString("base64"));
}
